import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { AppContextProvider } from '@contexts/AppContext';
import { subscribe_path } from '@routes';

import FooterSection from './FooterSection';
import HeaderSection from './HeaderSection';
import TimeLine from './TimeLine';

const OFFER_PARAM = 'read-us-first-pro,read-us-first-annual,read-us-first-monthly,read-us-first-yp';
const SUBSCRIBE_PROMO_URL = subscribe_path({ offer: OFFER_PARAM });

const queryClient = new QueryClient();

const BrandCampaign = ({ env, isWebview, isSubscriber }) => {
  return (
    <AppContextProvider env={env} isWebview={isWebview}>
      <QueryClientProvider client={queryClient}>
        <HeaderSection isSubscriber={isSubscriber} subscribePromoUrl={SUBSCRIBE_PROMO_URL} />
        <TimeLine />
        <FooterSection isSubscriber={isSubscriber} subscribePromoUrl={SUBSCRIBE_PROMO_URL} />
      </QueryClientProvider>
    </AppContextProvider>
  );
};

export default BrandCampaign;
